const space = {
  1: "0.25rem",
  2: "0.5rem",
  3: "0.75rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.5rem",
  10: "3rem",
  11: "3.5rem",
  12: "4rem",
  13: "5rem",
  14: "6rem",
  15: "7rem",
  16: "8rem",
  17: "9rem",
  18: "10rem",
  19: "11rem",
  20: "12rem",
  21: "16rem",
  22: "20rem",
};

export default space;
